export default __webpack_public_path__ + "static/fantasy_3-28b711636266d9f1247acde7cd4564dd.png";